import { AgentConfigDto, InquiryPublicDto, InquiryStatus } from '@paladin-monorepo/common';

/** Fields required to decide LLM new-session inquiry eligibility. */
export type InquiryForLlmChatSessionPick = Pick<
  InquiryPublicDto,
  'id' | 'status' | 'ndaRequired' | 'ndaAccepted' | 'userOffer'
>;

export function isNdaPending(inquiry: InquiryForLlmChatSessionPick): boolean {
  return inquiry.ndaRequired === true && inquiry.ndaAccepted !== true;
}

function passesListFilter(inquiry: InquiryForLlmChatSessionPick): boolean {
  return inquiry.status !== InquiryStatus.Evaluated && !inquiry.userOffer;
}

/** Inquiries shown in the new-session picker (NDA-pending rows remain visible but locked). */
export function filterInquiriesForNewSessionPicker<T extends InquiryForLlmChatSessionPick>(
  inquiries: T[],
): T[] {
  return inquiries.filter(passesListFilter);
}

/** Inquiries the user can actually select to start a supplier LLM session. */
export function filterSelectableInquiriesForNewSession<T extends InquiryForLlmChatSessionPick>(
  inquiries: T[],
): T[] {
  return filterInquiriesForNewSessionPicker(inquiries).filter((i) => !isNdaPending(i));
}

export function agentConfigRequiresInquiryBinding(
  config: Pick<AgentConfigDto, 'requiresInquiry'>,
): boolean {
  return config.requiresInquiry;
}
